import React from 'react';
import { colors } from '../../../theme';
import { S } from '../dashboardStyles';
import EmptyState from '../EmptyState';
import { Phone, PhoneCall, Clock, PhoneIncoming, PhoneOutgoing, PhoneMissed, PhoneOff } from 'lucide-react';

// Who called whom, and how it ended, are two different things. This map used
// to answer the first question with the second: status 'ringing' drew an
// INCOMING arrow and 'answered' an OUTGOING one, whatever the direction
// actually was — so a call you placed showed up as an incoming one. Direction
// is now the row's own arrow (below); this is only the outcome.
const OUTCOME = {
  ended:     { Icon: PhoneOff,     color: colors.green,   text: 'Завершён' },
  answered:  { Icon: PhoneCall,    color: colors.green,   text: 'Принят' },
  ringing:   { Icon: Phone,        color: colors.gray500, text: 'Вызов' },
  missed:    { Icon: PhoneMissed,  color: colors.red,     text: 'Пропущен' },
  declined:  { Icon: PhoneOff,     color: colors.gray500, text: 'Отклонён' },
  busy:      { Icon: PhoneOff,     color: colors.amber,   text: 'Занято' },
  cancelled: { Icon: PhoneOff,     color: colors.gray500, text: 'Отменён' },
  failed:    { Icon: PhoneOff,     color: colors.red,     text: 'Ошибка' },
};
const FALLBACK = { Icon: Phone, color: colors.gray400, text: '' };

export default function HistoryTab({ history, user, callUser, fmtDate, fmtDur, groupByDate }) {
  return (
    <div>
      {history.length === 0 && <EmptyState icon={Clock} text="Пока нет звонков" />}
      {groupByDate(history).map(([dateLabel, calls]) => (
        <div key={dateLabel}>
          <div style={S.dateLabel}>{dateLabel}</div>
          <div style={S.cardList}>
            {calls.map(call => {
              const isCaller = call.caller_id === user.id;
              const otherName = isCaller ? (call.callee_name_resolved || call.link_code || 'Гость') : (call.caller_name || '?');
              const otherExt = isCaller ? call.callee_ext : call.caller_ext;
              const otherId = isCaller ? call.callee_id : call.caller_id;
              const outcome = OUTCOME[call.status] || FALLBACK;
              const outcomeIcon = <outcome.Icon size={18} color={outcome.color} />;
              return (
                <div key={call.id} style={{ ...S.historyRow, cursor: otherExt ? 'pointer' : 'default' }}
                     onClick={() => otherExt && callUser(otherExt, otherId)}>
                  <span style={{ display: 'flex', alignItems: 'center' }}>{outcomeIcon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={S.historyName}>
                      {isCaller ? <PhoneOutgoing size={12} color={colors.gray400} style={{ marginRight: 4 }} /> : <PhoneIncoming size={12} color={colors.gray400} style={{ marginRight: 4 }} />}
                      {otherName}
                    </div>
                    <div style={S.historySub}>
                      {fmtDate(call.created_at)}
                      {call.duration_sec > 0 && ` · ${fmtDur(call.duration_sec)}`}
                      {` · ${outcome.text || call.status}`}
                    </div>
                  </div>
                  {otherExt && (
                    <button onClick={(e) => { e.stopPropagation(); callUser(otherExt, otherId); }} style={S.compactIconBtn}>
                      <Phone size={16} color={colors.gray600} />
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
